import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pulumi = defineConnector({
  identifier: "pulumi",
  name: "Pulumi",
  tagLine: "Infrastructure as code using real languages",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.pulumi\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: app.secret.accessToken, scheme: "token" },
    ]),
  steps: [
    {
      title: "Get your Pulumi access token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Pulumi Cloud console](https://app.pulumi.com/), go to **Settings → Access Tokens** and create a new personal access token.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Pulumi access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.pulumi.com/api/user",
  },
});
